import React from "react";
import { Link } from "react-router-dom";
import "./GameHistoryOverview.css";

const GameHistoryOverview = () => {
  return (
    <div className="game-history-container">
      <h2>Game Histories</h2>
      <div className="game-history-list">
        <Link to="/game-history/onePiece" className="game-history-link">
          <div className="game-history-card">One Piece History</div>
        </Link>
        <Link to="/game-history/naruto" className="game-history-link">
          <div className="game-history-card">Naruto History</div>
        </Link>
        <Link to="/game-history/bleach" className="game-history-link">
          <div className="game-history-card">Bleach History</div>
        </Link>
        <Link to="/game-history/onePunch" className="game-history-link">
          <div className="game-history-card">One Punch History</div>
        </Link>
      </div>
    </div>
  );
};

export default GameHistoryOverview;
